import p from "styled-components";
import { Column as n } from "./atoms-v212.js";
import { Grid as a } from "./atoms-v216.js";
import { Base as r } from "./atoms-v2777.js";
import { breakpoints as d } from "./atoms-v2125.js";
import { Icon as t } from "./atoms-v217.js";
import { Text as s } from "./atoms-v243.js";
const k = p(a)`
  ${r}

  padding-bottom: 20px;
  padding-top: 20px;
  row-gap: 16px;

  @media ${d.medium} {
    padding-bottom: 40px;
    padding-top: 40px;
  }

  @media ${d.large} {
    padding-bottom: 0;
    padding-top: 0;
    row-gap: 0;
  }
`, y = p(n)`
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${({ theme: o }) => {
  var i;
  return (i = o == null ? void 0 : o.get("tokens.body.expressive")) == null ? void 0 : i.toJS();
}}

  @media ${d.small} {
    ${({ theme: o }) => {
  var i;
  return (i = o == null ? void 0 : o.get("tokens.body.productive")) == null ? void 0 : i.toJS();
}}
  }
`, J = p.h5`
  ${({ theme: o }) => {
  var i;
  return (i = o == null ? void 0 : o.get("tokens.heading.03")) == null ? void 0 : i.toJS();
}}

  margin: 0;

  @media ${d.small} {
    ${({ theme: o }) => {
  var i;
  return (i = o == null ? void 0 : o.get("tokens.heading.02")) == null ? void 0 : i.toJS();
}}
  }

  @media ${d.xLarge} {
    ${({ theme: o }) => {
  var i;
  return (i = o == null ? void 0 : o.get("tokens.heading.04")) == null ? void 0 : i.toJS();
}}
  }
`, S = p.div`
  align-items: flex-start;
  display: flex;
  gap: 10px;
`, u = p(t)`
  flex-shrink: 0;
  padding-top: 2px;
`, v = p(s)`
  ${({ theme: o }) => {
  var i;
  return (i = o == null ? void 0 : o.get("tokens.helper.productive")) == null ? void 0 : i.toJS();
}}

  @media ${d.medium} {
    ${({ theme: o }) => {
  var i;
  return (i = o == null ? void 0 : o.get("tokens.body.productive")) == null ? void 0 : i.toJS();
}}
  }

  @media ${d.max} {
    ${({ theme: o }) => {
  var i;
  return (i = o == null ? void 0 : o.get("tokens.body.expressive")) == null ? void 0 : i.toJS();
}}
  }
`, C = p(n)`
  border-top: 1px solid ${({ theme: o }) => o == null ? void 0 : o.get("tokens.border.light.light")};
  display: none;
  padding-bottom: 24px;

  @media ${d.large} {
    display: block;
  }
`;
export {
  y as Content,
  C as Header,
  k as Policy,
  u as PolicyIcon,
  S as PolicyItem,
  v as TextContent,
  J as Title
};
